import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { getShoppingContextInput } from 'stores/adapters';
import { InfositeQueryAdapter } from 'stores/adapters/infosite-query-adapter';
export const getPropertyOffersInput = (context, currentHotel, urlParameters, multiItemContext) => {
  const {
    searchCriteria,
    hotelId,
    l10n
  } = currentHotel;
  const searchCriteriaJson = (searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.toJSON()) || {};
  const criteria = Object.assign(Object.assign({}, InfositeQueryAdapter.parseOut(searchCriteriaJson, l10n)), searchCriteriaJson);
  const {
    selectedRatePlan,
    selectedRoomType,
    badgeType,
    top_dp: srpDisplayPrice,
    top_cur: srpCurrency,
    mipt: multiItemPriceToken,
    pwa_ts: offerTimestamp,
    rfrr: referrer,
    srpStartDate: originalStartDate,
    srpEndDate: originalEndDate
  } = urlParameters;
  return {
    propertyId: String(hotelId),
    searchCriteria: adaptSearchCriteria(context, criteria),
    shoppingContext: getShoppingContextInput(multiItemContext),
    travelAdTrackingInfo: getTravelAdTrackingInfo(criteria),
    searchOffer: getSearchOffer(selectedRoomType, selectedRatePlan, badgeType, multiItemPriceToken, srpDisplayPrice, srpCurrency, offerTimestamp, originalStartDate, originalEndDate),
    referrer: referrer || null
  };
};
export const getTravelAdTrackingInfo = criteria => {
  if (criteria.trackingData) {
    return {
      beaconIssued: criteria.beaconIssued,
      candidateHmGuid: criteria.candidateHmGuid,
      position: criteria.position,
      rank: criteria.rank,
      slots: criteria.slots,
      testVersionOverride: criteria.testVersionOverride,
      trackingData: criteria.trackingData
    };
  }
  return null;
};
export const getSearchOffer = (selectedRoomType, selectedRatePlan, badgeType, multiItemPriceToken, srpDisplayPrice, srpCurrency, offerTimestamp, originalStartDate, originalEndDate) => {
  if (selectedRoomType && selectedRatePlan) {
    return {
      offerPrice: getOfferPrice(multiItemPriceToken, srpDisplayPrice, srpCurrency, offerTimestamp),
      roomTypeId: selectedRoomType,
      ratePlanId: selectedRatePlan,
      offerDetails: getOfferDetails(badgeType, originalStartDate, originalEndDate)
    };
  }
  return null;
};
export const getOfferDetails = (badgeType, originalStartDate, originalEndDate) => {
  const originalDateRange = originalStartDate && originalEndDate ? [{
    id: 'srpStartDate',
    value: originalStartDate
  }, {
    id: 'srpEndDate',
    value: originalEndDate
  }] : [];
  const badge = badgeType ? [{
    id: 'selectedRoomBadgeType',
    value: 'brandedDeal'
  }] : [];
  return [...originalDateRange, ...badge];
};
export const getOfferPrice = (priceToken, srpDisplayPrice, srpCurrency, offerTimestamp) => {
  if (priceToken || srpDisplayPrice && srpCurrency) {
    return {
      multiItemPriceToken: priceToken,
      offerTimestamp,
      price: srpDisplayPrice && {
        amount: Number(srpDisplayPrice),
        currency: srpCurrency
      } || null
    };
  }
  return null;
};